module.exports = __webpack_public_path__ + "static/assets/de036dee3232a8a9dfa4f5067fc0fe48.svg";